/*
 * biobio-carrinho.js: a gaveta do carrinho (spec docs/specs/2026-09-30-carrinho-gaveta-design.md).
 *
 * Tudo por delegacao no document, num asset carregado FORA do .cart-summary:
 * theme.updateCartSummaries troca o .cart-summary inteiro e descarta <script>
 * executavel, entao nada aqui depende de viver dentro do HTML redesenhado.
 *
 * Contratos com o theme.js (conferidos em 30/09/2026):
 * - cc-cart-updated e disparado por jQuery(window).trigger (linha 3871): um
 *   addEventListener nativo NUNCA o recebe. A inscricao e jQuery(window).on,
 *   com MutationObserver no pai do #cart-summary como reserva.
 * - O jQuery e o DO TEMA (theme.jQuery, ver jqDoTema): um app da loja troca
 *   window.jQuery por outra instancia logo depois da carga (01/10/2026).
 * - Adicionar e sempre fetch('/cart/add.js'); nunca submit nativo e NUNCA
 *   /cart em caso de erro: a Yampi leva ao checkout com clearCart=1 e esvazia
 *   o carrinho da loja.
 * - updateCartSummaries(false, true, false): a gaveta ja esta aberta, "false"
 *   para o tema nao mandar o foco ao X a cada adicao.
 *
 * Partes: medir (funil), status (faixa unica), storage (escolha explicita),
 * cartao (tom, preco, foto, botao), adicionar (estados), redesenho (espera),
 * abriu/viu, e no fim a delegacao LEGADA do form antigo (rede de seguranca se
 * um push de outra frente devolver o markup velho da section).
 * Toda medicao e try/catch por destino: medicao quebrada nao derruba a compra.
 */
(function () {
  if (window.__biobioCarrinho) return;
  window.__biobioCarrinho = true;

  var ERRO_PADRAO = 'Não foi possível adicionar. Tente de novo.';
  var CHAVE_STORAGE = 'biobio-carrinho-rec';
  // A amostra da faixa e o render do biobio-bundle-swatch com a classe trocada no Liquid (C1 da revisao
  // final): NUNCA .swatch. O assets/sticky-button.js das PDPs legadas monta a barra fixa com TODA .swatch
  // da pagina e marca o primeiro '.swatch input[value=...]' do DOM, que seria o da gaveta (ela vem antes do
  // conteudo); e o VariantPickerSwatches do theme.js (7096) cancela todo clique em .swatch.
  var AMOSTRA = 'carrinho-amostra';
  var ORIGEM = 'carrinho-recomendados';
  var ocupado = false;
  var timerStatus = null;

  function cfg(chave, padrao) {
    var c = window.__biobioCarrinhoCfg || {};
    return c[chave] === undefined ? padrao : c[chave];
  }

  // O jQuery DO TEMA. O theme.js roda em (function ($) {...})(theme.jQuery) (vendor.min.js linha 3 faz
  // theme.jQuery = $) e dispara cc-cart-updated e o .trigger('change') da quantidade NESSA instancia.
  // Um app da loja injeta um 2o jQuery (3.6.0, ajax.googleapis.com) que troca window.jQuery de 50 a
  // 160 ms depois do vendor (medido no snapshot em 01/10/2026), as vezes antes e as vezes depois do
  // DOMContentLoaded: handler ligado, ou trigger feito, em outra instancia nunca se encontram.
  function jqDoTema() {
    return (window.theme && window.theme.jQuery) || window.jQuery || null;
  }

  /* ---------- medir: Clarity, Hotjar, GTM (dataLayer), Shopify.analytics ---------- */
  var medido = {};
  function medir(etapa, payload, unico) {
    if (unico) {
      if (medido[etapa]) return;
      medido[etapa] = true;
    }
    var nome = etapa === 'abriu' ? 'carrinho_abriu' : 'carrinho_rec_' + etapa;
    var dados = payload || {};
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('set', 'carrinho_recomendados', etapa);
        window.clarity('event', nome);
      }
    } catch (e) {}
    try { if (typeof window.hj === 'function') window.hj('event', nome); } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      var ev = { event: nome };
      for (var k in dados) if (Object.prototype.hasOwnProperty.call(dados, k)) ev[k] = dados[k];
      window.dataLayer.push(ev);
    } catch (e) {}
    try {
      var sa = window.Shopify && window.Shopify.analytics;
      if (sa && typeof sa.publish === 'function') sa.publish(nome, dados);
    } catch (e) {}
  }
  window.BioBioCarrinhoMedir = medir;

  /* ---------- status: a faixa VISUAL (sem role) e UM anunciador persistente ----------
     A mensagem vive no estado do JS (mensagem), nao no no: todo redesenho troca o #cart-summary inteiro
     (o nosso, o do tema nas quantidades, o do app de brindes a cada fg-gifts:updated), e a faixa nova
     nasce vazia. aoRedesenhar reescreve a mensagem viva na faixa nova, e o cronometro, que e um so e nao
     depende do no, continua contando o tempo que faltava (I2 da revisao final).
     Quem anuncia e um role=status UNICO, criado pelo JS no body, fora do no trocado: uma live region
     recriada a cada redesenho, ou escrita no mesmo instante em que deixa de ser hidden, pode ficar muda
     no VoiceOver. Limpa e escreve ~100 ms depois, para a mesma frase ser anunciada de novo (I3). */
  var mensagem = null; // { texto, classe, acao: { rotulo, nome, fn }, emVoo }
  var anunciador = null;
  var timerAnuncio = null;
  function faixa() { return document.querySelector('[data-carrinho-aviso]'); }

  function noAnunciador() {
    if (anunciador && document.body && document.body.contains(anunciador)) return anunciador;
    if (!document.body) return null;
    anunciador = document.createElement('div');
    anunciador.className = 'carrinho-anuncio';
    anunciador.setAttribute('role', 'status');
    anunciador.setAttribute('data-carrinho-anuncio', '');
    // Fora da gaveta, o CSS escopado em .cart-summary nao alcanca: oculto visualmente aqui mesmo.
    anunciador.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;border:0;overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);white-space:nowrap';
    document.body.appendChild(anunciador);
    return anunciador;
  }
  function anunciar(texto) {
    var a = noAnunciador();
    if (!a) return;
    clearTimeout(timerAnuncio);
    a.textContent = '';
    timerAnuncio = setTimeout(function () { a.textContent = texto; }, cfg('msAnuncio', 100));
  }

  function desenharMensagem(el, m) {
    el.textContent = '';
    el.className = 'carrinho-aviso' + (m.classe ? ' ' + m.classe : '');
    var span = document.createElement('span');
    span.textContent = m.texto;
    el.appendChild(span);
    if (m.acao) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'carrinho-aviso__acao';
      b.setAttribute('data-carrinho-aviso-acao', '');
      b.textContent = m.acao.rotulo;
      if (m.acao.nome) b.setAttribute('aria-label', m.acao.nome);
      if (m.emVoo) b.setAttribute('aria-disabled', 'true');
      el.appendChild(b);
    }
    el.hidden = false;
    el.__mensagem = m;
  }
  // Redesenho trocou a faixa: a mensagem viva volta na faixa nova, sem novo anuncio e sem novo prazo.
  function reaplicarMensagem() {
    var el = faixa();
    if (!mensagem || !el || el.__mensagem === mensagem) return;
    desenharMensagem(el, mensagem);
  }
  function apagarMensagem() {
    mensagem = null;
    var el = faixa();
    if (el) { el.hidden = true; el.textContent = ''; el.__mensagem = null; }
    clearTimeout(timerAnuncio);
    if (anunciador) anunciador.textContent = '';
  }

  function status(texto, opcoes) {
    var el = faixa();
    if (!el) return null;
    opcoes = opcoes || {};
    clearTimeout(timerStatus);
    mensagem = { texto: texto, classe: opcoes.classe || '', acao: opcoes.acao || null, emVoo: false };
    desenharMensagem(el, mensagem);
    anunciar(texto);
    if (opcoes.ms) agendarSumico(opcoes.ms);
    return el;
  }
  window.BioBioCarrinhoStatus = status;

  // Um cronometro so, que olha a faixa ATUAL: pausa enquanto ela tem foco ou hover (o Desfazer nao some
  // sob o dedo nem sob o foco) e segue valendo depois de qualquer redesenho.
  function agendarSumico(ms) {
    clearTimeout(timerStatus);
    timerStatus = setTimeout(function () {
      var el = faixa();
      var focado = !!el && el.contains(document.activeElement);
      var sobre = false;
      try { sobre = !!el && el.matches(':hover'); } catch (e) {}
      if (focado || sobre) { agendarSumico(1500); return; }
      apagarMensagem();
    }, ms);
  }

  // Troca SO o texto da mensagem e mantem o botao de acao no lugar (com o foco que ele tiver):
  // desabilitado (aria-disabled, segue focavel) enquanto a acao esta em voo. Sem botao, cai no status().
  function atualizarFaixa(texto, acaoEmVoo) {
    var el = faixa();
    var span = el && el.querySelector('span');
    var b = el && el.querySelector('[data-carrinho-aviso-acao]');
    if (!span || !b || !mensagem || !mensagem.acao) return status(texto, {});
    clearTimeout(timerStatus); // nao some no meio do envio
    mensagem.texto = texto;
    mensagem.emVoo = !!acaoEmVoo;
    span.textContent = texto;
    if (acaoEmVoo) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
    el.hidden = false;
    anunciar(texto);
    return el;
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-carrinho-aviso-acao]');
    if (!b || b.getAttribute('aria-disabled') === 'true') return;
    if (mensagem && mensagem.acao && typeof mensagem.acao.fn === 'function') mensagem.acao.fn();
  });

  /* ---------- storage: so escolha explicita feita na faixa, nesta sessao ---------- */
  function lerEscolhas() {
    try { return JSON.parse(sessionStorage.getItem(CHAVE_STORAGE) || '{}') || {}; } catch (e) { return {}; }
  }
  function guardarEscolha(pid, vid) {
    try { var m = lerEscolhas(); m[pid] = vid; sessionStorage.setItem(CHAVE_STORAGE, JSON.stringify(m)); } catch (e) {}
  }
  function esquecerEscolha(pid) {
    try { var m = lerEscolhas(); delete m[pid]; sessionStorage.setItem(CHAVE_STORAGE, JSON.stringify(m)); } catch (e) {}
  }

  /* ---------- cartao ---------- */
  function dadosDoCartao(card) {
    if (card.__dados !== undefined) return card.__dados;
    try { card.__dados = JSON.parse(card.querySelector('[data-rec-json]').textContent); } catch (e) { card.__dados = null; }
    return card.__dados;
  }
  function varianteDe(card, vid) {
    var d = dadosDoCartao(card);
    if (!d) return null;
    for (var i = 0; i < d.variantes.length; i++) if (String(d.variantes[i].id) === String(vid)) return d.variantes[i];
    return null;
  }
  // Formato da loja (theme.money_format): <span class=money>R$ {{amount_with_comma_separator}}</span>
  function money(centavos) {
    var fmt = (window.theme && window.theme.money_format) || '<span class=money>R$ {{amount_with_comma_separator}}</span>';
    var partes = (Math.round(centavos) / 100).toFixed(2).split('.');
    var inteiro = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, inteiro + ',' + partes[1]);
  }
  function textoDoBotao(add, texto) {
    var t = add.querySelector('[data-rec-add-texto]');
    if (t) t.textContent = texto; else add.textContent = texto;
  }

  function aplicarEscolha(card, variante) {
    var d = dadosDoCartao(card) || {};
    var tom = card.querySelector('[data-rec-tom]');
    var preco = card.querySelector('[data-rec-preco]');
    var img = card.querySelector('[data-rec-img]');
    var off = card.querySelector('[data-rec-off]');
    var varia = card.querySelector('[data-rec-varia]');
    var temDesconto = variante.compare > variante.preco;
    if (tom) { tom.textContent = variante.tom; tom.hidden = false; }
    if (preco) preco.innerHTML = (temDesconto ? '<s>' + money(variante.compare) + '</s>' : '') + money(variante.preco);
    if (varia) varia.hidden = true;
    if (img && variante.imagem) img.src = variante.imagem;
    if (off) {
      if (temDesconto) {
        off.textContent = '-' + Math.round((variante.compare - variante.preco) * 100 / variante.compare) + '%';
        off.hidden = false;
      } else {
        off.hidden = true;
      }
    }
    var add = card.querySelector('[data-rec-add]');
    if (add) {
      add.setAttribute('data-rec-estado', 'adicionar');
      add.setAttribute('data-rec-variante', variante.id);
      add.classList.remove('carrinho-rec__add--escolher');
      add.removeAttribute('aria-describedby');
      add.setAttribute('aria-label', 'Adicionar ' + (d.nome || '') + ' ' + variante.tom);
      textoDoBotao(add, 'Adicionar');
    }
    var amostras = card.querySelectorAll('.' + AMOSTRA);
    for (var i = 0; i < amostras.length; i++) {
      var marcado = String(amostras[i].getAttribute('data-variant-id')) === String(variante.id);
      amostras[i].classList.toggle(AMOSTRA + '--selected', marcado);
      var input = amostras[i].querySelector('input');
      if (input && marcado && !input.checked) input.checked = true;
    }
  }

  // Tom esgotou entre a escolha e o toque: risca a amostra, desmarca, botao volta a "escolher".
  function invalidarEscolha(card, vid) {
    var d = dadosDoCartao(card) || {};
    var v = varianteDe(card, vid);
    if (v) v.disponivel = false;
    var amostras = card.querySelectorAll('.' + AMOSTRA);
    for (var i = 0; i < amostras.length; i++) {
      if (String(amostras[i].getAttribute('data-variant-id')) !== String(vid)) continue;
      amostras[i].classList.add(AMOSTRA + '--disabled');
      amostras[i].classList.remove(AMOSTRA + '--selected');
      var input = amostras[i].querySelector('input');
      if (input) {
        input.disabled = true;
        input.checked = false;
        // Riscada diz "esgotado" no nome acessivel (spec 5.6), como a que ja nasce riscada no Liquid.
        var nome = input.getAttribute('aria-label') || '';
        if (!/esgotado/.test(nome)) input.setAttribute('aria-label', nome + ', esgotado');
      }
    }
    var tom = card.querySelector('[data-rec-tom]');
    if (tom) { tom.hidden = true; tom.textContent = ''; }
    var add = card.querySelector('[data-rec-add]');
    if (add) {
      add.setAttribute('data-rec-estado', 'escolher');
      add.removeAttribute('data-rec-variante');
      add.classList.add('carrinho-rec__add--escolher');
      add.removeAttribute('aria-label');
      var dica = card.querySelector('.visually-hidden[id^="carrinho-rec-dica-"]');
      if (dica) add.setAttribute('aria-describedby', dica.id);
      textoDoBotao(add, add.__rotuloEscolher || 'Escolha o tom');
    }
    esquecerEscolha(card.getAttribute('data-rec-pid'));
    status('Esse tom esgotou. Escolha outro', { ms: 6000 });
  }

  /* Radios da faixa so ficam marcados com a gaveta ABERTA. O VariantPickerSwatches
     do theme.js (linha 7247) junta TODO input[type=radio]:checked do documento para
     achar a variante da PDP: um carrinho-rec-<pid> marcado vira uma opcao que
     nenhuma variante tem, e o seletor nativo da PDP para de trocar a variante.
     Ao fechar, desmarca (o sessionStorage guarda a escolha); ao abrir e a cada
     redesenho com a gaveta aberta, restaura. Gaveta fechada nunca restaura. */
  function gavetaAberta() {
    return !!document.body && document.body.classList.contains('show-cart-summary');
  }
  function desmarcarFaixa() {
    var inputs = document.querySelectorAll('[data-rec-card] .' + AMOSTRA + ' input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      inputs[i].checked = false;
      var label = inputs[i].closest('.' + AMOSTRA);
      if (label) label.classList.remove(AMOSTRA + '--selected');
    }
  }
  // As marcas do cartao voltam a dizer o tom que o botao de fato tem (data-rec-variante) e so ele; com a
  // gaveta fechada, nenhum. Usado quando um toque nao pode valer (riscada, cartao adicionando).
  function remarcar(card) {
    var add = card.querySelector('[data-rec-add]');
    var escolhido = gavetaAberta() && add ? add.getAttribute('data-rec-variante') : null;
    var amostras = card.querySelectorAll('.' + AMOSTRA);
    for (var i = 0; i < amostras.length; i++) {
      var input = amostras[i].querySelector('input[type="radio"]');
      var sim = !!escolhido && amostras[i].getAttribute('data-variant-id') === escolhido && !!input && !input.disabled;
      if (input) input.checked = sim;
      amostras[i].classList.toggle(AMOSTRA + '--selected', sim);
    }
  }

  function restaurarEscolhas(raiz) {
    if (!gavetaAberta()) return;
    var m = lerEscolhas();
    var cards = (raiz || document).querySelectorAll('[data-rec-card]');
    for (var i = 0; i < cards.length; i++) {
      var pid = cards[i].getAttribute('data-rec-pid');
      if (!m[pid]) continue;
      var v = varianteDe(cards[i], m[pid]);
      var label = cards[i].querySelector('.' + AMOSTRA + '[data-variant-id="' + m[pid] + '"]');
      var input = label && label.querySelector('input');
      if (v && v.disponivel && input && !input.disabled) aplicarEscolha(cards[i], v);
      else esquecerEscolha(pid);
    }
  }

  // Escolha pelo 'change' nativo do radio: toque, clique no rotulo, Espaco e setas. Com a classe do
  // carrinho, o VariantPickerSwatches do theme.js (7096: preventDefault em TODO clique em .swatch, radio
  // marcado em codigo, nenhum 'change') nao alcanca mais a faixa, entao o 'change' sempre chega e um toque
  // produz UMA escolha. O 'click' fica so como rede: se OUTRO script cancelar o clique (sem 'change'),
  // a escolha acontece depois do evento, uma vez.
  function escolher(card, label) {
    var input = label && label.querySelector('input[type="radio"]');
    if (!card || !input) return;
    // Gaveta fechada (C1, defesa em profundidade): um radio da faixa marcado com a gaveta fechada entra na
    // varredura do seletor da PDP (theme.js 7247). Nada se escolhe, grava ou mede, e o radio fica desmarcado.
    if (!gavetaAberta()) { input.checked = false; label.classList.remove(AMOSTRA + '--selected'); return; }
    // Cartao adicionando (M2): o toque nao troca o tom do que esta em voo; as marcas voltam ao tom do envio.
    if (card.hasAttribute('data-rec-ocupado')) { remarcar(card); return; }
    if (input.disabled) return;
    var v = varianteDe(card, label.getAttribute('data-variant-id'));
    if (!v) return;
    var addEl = card.querySelector('[data-rec-add]');
    if (addEl) rotuloEscolher(addEl); // guarda "Escolha o tom"/"Escolha a cor" antes de trocar por "Adicionar"
    aplicarEscolha(card, v);
    guardarEscolha(card.getAttribute('data-rec-pid'), v.id);
    medir('interagiu', { gesto: 'amostra' }, true);
  }
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('[data-rec-card] .' + AMOSTRA + ' input[type="radio"]')) return;
    escolher(input.closest('[data-rec-card]'), input.closest('.' + AMOSTRA));
  });
  document.addEventListener('click', function (e) {
    var label = e.target && e.target.closest && e.target.closest('[data-rec-card] .' + AMOSTRA);
    if (!label) return;
    var card = label.closest('[data-rec-card]');
    setTimeout(function () {
      var input = label.querySelector('input[type="radio"]');
      // Gaveta fechada (M3): nada e re-marcado; o que um script de fora marcou sai.
      if (!gavetaAberta()) { remarcar(card); return; }
      // Clique cancelado por outro script: nao houve 'change'. Escolhe agora (marca o radio de novo).
      if (e.defaultPrevented) escolher(card, label);
      // Radio riscado marcado em codigo por quem cancelou: diria ao leitor de tela que o tom foi
      // escolhido com o botao em "Escolha o tom". As marcas voltam ao tom escolhido (se houver).
      if (input && input.disabled && input.checked) remarcar(card);
    }, 0);
  });

  /* ---------- erro no cartao ---------- */
  function erroNoCartao(card, mensagem) {
    var el = card.querySelector('[data-rec-erro]');
    if (!el) return;
    el.textContent = mensagem;
    el.hidden = false;
  }
  function limparErro(card) {
    var el = card.querySelector('[data-rec-erro]');
    if (el) { el.textContent = ''; el.hidden = true; }
  }

  /* ---------- a gaveta redesenhada diz o que esta no carrinho ---------- */
  function itensDaGaveta() {
    try { var el = document.getElementById('LimitedCartJson'); return el ? (JSON.parse(el.textContent).items || []) : null; } catch (e) { return null; }
  }
  function quantidadeNaGaveta(vid) {
    var itens = itensDaGaveta();
    if (!itens) return null;
    var q = 0;
    for (var i = 0; i < itens.length; i++) if (String(itens[i].id) === String(vid)) q += itens[i].quantity || 0;
    return q;
  }

  /* ---------- redesenho: esperar um cc-cart-updated que REFLITA a operacao ----------
     O evento do tema nao identifica a operacao que o originou (um "+" em voo
     pode chegar antes do nosso redesenho, com HTML velho). Por isso cada espera
     recebe uma conferencia que le o #LimitedCartJson redesenhado: so um
     redesenho que passa na conferencia resolve; os outros seguem esperando ate
     o prazo. Nao ha contador de sequencia: o estado recebido e a verdade. */
  var esperando = [];
  function aoRedesenhar() {
    var fila = esperando;
    esperando = [];
    for (var i = 0; i < fila.length; i++) {
      var resolvido = false;
      try { resolvido = fila[i](); } catch (e) { resolvido = true; }
      if (!resolvido) esperando.push(fila[i]);
    }
    depoisDoRedesenhoRemocao();
    reaplicarMensagem();
    restaurarEscolhas(document);
    cancelarViu();
    observarFaixa();
    // Os fluxos proprios focam nas promessas que ESTE redesenho resolveu (microtarefas); so depois deles,
    // se o foco ainda estiver no body, ele volta ao equivalente do que tinha (I2).
    setTimeout(restaurarFoco, 0);
  }
  function esperarRedesenho(ms, confere) {
    return new Promise(function (resolve) {
      var feito = false;
      var t = setTimeout(function () { if (!feito) { feito = true; resolve(false); } }, ms);
      esperando.push(function () {
        if (feito) return true;
        if (typeof confere === 'function' && !confere()) return false;
        feito = true;
        clearTimeout(t);
        resolve(true);
        return true;
      });
    });
  }
  function inscreverRedesenho() {
    var $ = jqDoTema();
    if ($) {
      try { $(window).on('cc-cart-updated', aoRedesenhar); return; } catch (e) {}
    }
    // Reserva sem jQuery: o no #cart-summary e trocado inteiro pelo tema.
    if (!document.body || !window.MutationObserver) return;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n.nodeType === 1 && (n.id === 'cart-summary' || (n.querySelector && n.querySelector('#cart-summary')))) { aoRedesenhar(); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  function redesenhar(abrir, confere) {
    var tema = window.theme || {};
    if (typeof tema.updateCartSummaries !== 'function') return Promise.resolve(false);
    tema.updateCartSummaries(!!abrir, true, false);
    return esperarRedesenho(cfg('timeoutRedesenho', 8000), confere);
  }
  function recarregar() {
    var r = cfg('recarregar', null);
    if (typeof r === 'function') r(); else window.location.reload();
  }

  /* ---------- rede ---------- */
  // fetch + leitura do corpo debaixo do MESMO prazo: so resolve ({ resposta, dados })
  // depois que o corpo chegou inteiro. Um prazo que parasse no cabecalho deixaria um
  // corpo travado pendurar a operacao (botao em "Adicionando...", "Finalizar compra"
  // segurado). Prazo estourado rejeita: leitura vira null, POST cai na conferencia.
  // Corpo que nao e JSON vira {}.
  function fetchJsonComTimeout(url, opcoes, ms) {
    return new Promise(function (resolve, reject) {
      var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      if (ctrl) opcoes.signal = ctrl.signal;
      var feito = false;
      var t = setTimeout(function () {
        if (feito) return;
        feito = true;
        if (ctrl) { try { ctrl.abort(); } catch (e) {} }
        reject(new Error('prazo'));
      }, ms);
      fetch(url, opcoes).then(function (resposta) {
        return resposta.text().then(function (texto) {
          var dados = {};
          try { dados = JSON.parse(texto); } catch (e) {}
          return { resposta: resposta, dados: dados };
        });
      }).then(function (r) {
        if (feito) return;
        feito = true;
        clearTimeout(t);
        resolve(r);
      }, function (e) {
        if (feito) return;
        feito = true;
        clearTimeout(t);
        reject(e);
      });
    });
  }
  // Le o carrinho do servidor com prazo proprio (corpo incluido). null = nao deu para ler (nao e "vazio").
  function lerCarrinho() {
    return fetchJsonComTimeout('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }, cfg('timeoutLeitura', 5000))
      .then(function (r) { var c = r.dados; return r.resposta.ok && c && c.items ? c : null; }, function () { return null; });
  }
  function quantidadeDe(carrinho, vid) {
    if (!carrinho) return null;
    var q = 0;
    for (var i = 0; i < carrinho.items.length; i++) {
      var it = carrinho.items[i];
      if (String(it.variant_id !== undefined ? it.variant_id : it.id) === String(vid)) q += it.quantity || 0;
    }
    return q;
  }

  /* ---------- mutacao com confirmacao: adicionar e desfazer usam a MESMA rotina ----------
     Resultado da promessa: 'confirmada' (servidor aceitou E a gaveta redesenhada
     reflete), 'desconhecida' (resposta perdida e sem como provar que entrou: a
     gaveta e redesenhada para mostrar a verdade, e NAO se autoriza reenvio cego),
     'recarregando' (aceita, mas o redesenho nao chegou duas vezes: recarga).
     Rejeita com { recusada: true, descricao } SO quando o servidor recusou (4xx);
     5xx e qualquer outra falha passam pela conferencia do /cart.js.
     NUNCA repete o POST. Uma operacao propria por vez (ocupado). */
  function executarMutacao(op) {
    if (ocupado) return Promise.resolve('ocupado');
    ocupado = true;
    // Pendencias do +/-/lixeira nao valem para o redesenho desta operacao.
    pendenteRemocao = null;
    pendenteQuantidade = null;
    var antes = null;
    var confere = function () {
      var q = quantidadeNaGaveta(op.variante);
      if (q === null) return false;
      return antes === null ? q > 0 : q > antes;
    };
    // Resposta perdida, prazo estourado (cabecalho OU corpo) ou falha que nao e
    // recusa (502/503/504 podem vir depois de um aceite no servidor). Uma leitura
    // com a quantidade maior prova que entrou; qualquer outra coisa (igual, menor,
    // leitura falha) NAO prova que nao entrou: desconhecida.
    var conferir = function () {
      return lerCarrinho().then(function (c) {
        var depois = quantidadeDe(c, op.variante);
        if (depois !== null && antes !== null && depois > antes) return 'aceita';
        var d = new Error('desconhecida');
        d.desconhecida = true;
        throw d;
      });
    };
    return lerCarrinho()
      .then(function (c) {
        antes = quantidadeDe(c, op.variante);
        return fetchJsonComTimeout('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: op.itens }),
        }, cfg('timeoutPost', 10000));
      })
      .then(function (r) {
        var resposta = r.resposta;
        var dados = r.dados || {};
        if (resposta.ok) return 'aceita';
        if (resposta.status >= 400 && resposta.status < 500) {
          // Esgotado e limite vem em portugues (description == message); "Cart Error" vem em ingles.
          var falha = new Error('HTTP ' + resposta.status);
          falha.recusada = true;
          falha.descricao = typeof dados.description === 'string' && dados.message !== 'Cart Error' ? dados.description : '';
          falha.esgotou = /esgot/i.test(falha.descricao);
          throw falha;
        }
        return conferir();
      }, conferir)
      .then(function () {
        if (typeof op.aoAceitar === 'function') { try { op.aoAceitar(); } catch (e) {} }
        return redesenhar(op.abrir, confere).then(function (ok) {
          if (ok) return 'confirmada';
          return redesenhar(op.abrir, confere).then(function (ok2) {
            if (ok2) return 'confirmada';
            recarregar();
            return 'recarregando';
          });
        });
      })
      .then(function (resultado) {
        ocupado = false;
        return resultado;
      }, function (falha) {
        if (falha && falha.desconhecida) {
          // Mostra a verdade do carrinho (a cliente decide) e so DEPOIS dela termina a operacao: aviso e foco
          // escritos antes seriam apagados por esse mesmo redesenho, e o botao e o "Finalizar compra" nao se
          // liberam antes de a gaveta dizer o que entrou (I1 da revisao final).
          return redesenhar(op.abrir, null).then(function () {
            ocupado = false;
            return 'desconhecida';
          });
        }
        ocupado = false;
        throw falha;
      });
  }

  /* ---------- foco depois de adicionar (a gaveta ja esta aberta: nunca o X) ---------- */
  function focarDepoisDeAdicionar(cardAntigo) {
    var cards = document.querySelectorAll('[data-rec-card]');
    var alvo = null;
    if (cards.length) {
      var pos = parseInt(cardAntigo && cardAntigo.getAttribute('data-rec-posicao'), 10) || 1;
      alvo = cards[Math.min(pos - 1, cards.length - 1)].querySelector('[data-rec-add]');
    }
    if (!alvo) alvo = document.querySelector('.carrinho-item__nome, .cart-summary-item__title') || document.querySelector('.cart-summary__close');
    focar(alvo, true); // pela guarda de gaveta aberta: uma confirmacao que chega com a gaveta fechada nao puxa o foco (M1)
  }

  /* ---------- remocao, quantidade e desfazer (spec 5.5, D12, D17; R21) ----------
     A lixeira, o mais, o menos e o Enter no campo sao do tema e terminam em
     $input.val(n).trigger('change') (theme.js 6008 a 6045): um trigger do jQuery
     NAO dispara evento nativo, entao a observacao e um handler jQuery DELEGADO,
     unico, que tambem recebe a edicao manual do campo (evento nativo). Sem jQuery
     (nunca no tema; so no harness da faixa), cai no listener nativo.
     GRUPO (R21): o desconto automatico "Leve 3 pague 2" parte a mesma variante com
     as mesmas propriedades em varias linhas e pode RE-CRIAR a chave tocada. A conta
     e por grupo (variante + propriedades normalizadas): no change guardamos o total
     do grupo; no redesenho, remocao = a chave sumiu OU o total caiu, e o Desfazer
     devolve a DIFERENCA. O anuncio de quantidade fala o total do grupo.
     So a ULTIMA remocao e recuperavel, por 5 s, nomeada. Desfazer re-adiciona pela
     MESMA rotina do adicionar (executarMutacao), sem _origem novo e sem evento
     adicionou. Pendencia com mais de 10 s (o change.js falhou e o tema so reabilitou
     os controles, sem redesenho) e descartada; o executarMutacao zera as pendencias.
     FOCO (spec 5.5): com a gaveta aberta nunca cai no body nem vai ao X. */
  var pendenteRemocao = null;    // { chave, variante, quantidade, propriedades, nome, grupo, totalAntes, indice, t }
  var pendenteQuantidade = null; // { chave, nome, grupo, controle, indice, t }
  var cliqueEmCurso = null;      // { chave, controle }: o +/- tocado, lido pelo change sincrono do tema

  // No render REAL da loja, {{ item.properties | json }} sai como ARRAY DE PARES
  // ([["_origem","carrinho-recomendados"],["_fonte","upsell"]]); o LiquidJS dos
  // testes da objeto. O /cart/add.js quer objeto: pares viram objeto, objeto passa,
  // array vazio ou qualquer outra coisa vira {}.
  function propriedadesComoObjeto(bruto) {
    var obj = {};
    if (Array.isArray(bruto)) {
      for (var i = 0; i < bruto.length; i++) {
        var par = bruto[i];
        if (Array.isArray(par) && par.length === 2 && typeof par[0] === 'string') obj[par[0]] = par[1];
      }
      return obj;
    }
    if (bruto && typeof bruto === 'object') return bruto;
    return obj;
  }
  function lerPropriedades(c) {
    try { return propriedadesComoObjeto(JSON.parse(c.getAttribute('data-properties') || '{}')); } catch (e) { return {}; }
  }
  // Grupo = variante + propriedades com as chaves ORDENADAS (a ordem dos pares nao muda o grupo).
  function chaveGrupo(variante, props) {
    var ks = Object.keys(props || {}).sort();
    var ordenado = {};
    for (var i = 0; i < ks.length; i++) ordenado[ks[i]] = props[ks[i]];
    return String(variante) + '|' + JSON.stringify(ordenado);
  }
  function linhasDaGaveta() { return document.querySelectorAll('.cart-summary-item-container[data-line-key]'); }
  function linhaPorChave(chave) {
    var ls = linhasDaGaveta();
    for (var i = 0; i < ls.length; i++) if (ls[i].getAttribute('data-line-key') === chave) return ls[i];
    return null;
  }
  function grupoDe(c) { return chaveGrupo(parseInt(c.getAttribute('data-variant-id'), 10), lerPropriedades(c)); }
  function linhaDoGrupo(grupo) {
    var ls = linhasDaGaveta();
    for (var i = 0; i < ls.length; i++) if (grupoDe(ls[i]) === grupo) return ls[i];
    return null;
  }
  // Soma de data-quantity das linhas do grupo: antes do redesenho, e o carrinho do ultimo redesenho.
  function totalDoGrupo(grupo) {
    var ls = linhasDaGaveta();
    var t = 0;
    for (var i = 0; i < ls.length; i++) if (grupoDe(ls[i]) === grupo) t += parseInt(ls[i].getAttribute('data-quantity'), 10) || 0;
    return t;
  }
  function dadosDaLinha(el) {
    var c = el.closest('.cart-summary-item-container');
    if (!c || !c.hasAttribute('data-line-key')) return null;
    var props = lerPropriedades(c);
    var variante = parseInt(c.getAttribute('data-variant-id'), 10);
    var nomeEl = c.querySelector('.carrinho-item__nome, .cart-summary-item__title');
    var ls = linhasDaGaveta();
    var indice = 0;
    for (var i = 0; i < ls.length; i++) if (ls[i] === c) indice = i;
    return {
      chave: c.getAttribute('data-line-key'),
      variante: variante,
      quantidade: parseInt(c.getAttribute('data-quantity'), 10) || 1,
      propriedades: props,
      nome: nomeEl ? nomeEl.textContent.trim() : 'Item',
      grupo: chaveGrupo(variante, props),
      indice: indice,
    };
  }
  function tratarMudancaDeQuantidade(input) {
    var d = dadosDaLinha(input);
    if (!d) return;
    var n = parseInt(input.value, 10);
    if (isNaN(n)) return;
    d.t = Date.now();
    if (n <= 0) {
      d.totalAntes = totalDoGrupo(d.grupo);
      pendenteRemocao = d;
      pendenteQuantidade = null;
    } else {
      // mais/menos: o controle tocado; edicao manual (Enter ou sair do campo): o proprio campo
      var controle = cliqueEmCurso && cliqueEmCurso.chave === d.chave ? cliqueEmCurso.controle : 'qty-adjuster__value';
      pendenteQuantidade = { chave: d.chave, nome: d.nome, grupo: d.grupo, controle: controle, indice: d.indice, t: d.t };
    }
  }
  function observarQuantidade() {
    var $ = jqDoTema();
    if ($) {
      $(document).on('change', '.qty-adjuster--ajax .qty-adjuster__value', function () { tratarMudancaDeQuantidade(this); });
    } else {
      document.addEventListener('change', function (e) {
        if (e.target && e.target.matches && e.target.matches('.qty-adjuster--ajax .qty-adjuster__value')) tratarMudancaDeQuantidade(e.target);
      });
    }
    // Qual +/- a cliente tocou: o click do tema dispara o change NA MESMA volta do evento, entao a
    // marca vale so ate o fim dela. Um change sem clique (Enter ou sair do campo) mira o proprio campo.
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.qty-adjuster--ajax .qty-adjuster__down, .qty-adjuster--ajax .qty-adjuster__up');
      var c = b && b.closest('.cart-summary-item-container');
      if (!c) return;
      cliqueEmCurso = { chave: c.getAttribute('data-line-key'), controle: b.classList.contains('qty-adjuster__up') ? 'qty-adjuster__up' : 'qty-adjuster__down' };
      setTimeout(function () { cliqueEmCurso = null; }, 0);
    }, true);
  }

  /* ---------- foco: nunca no body nem no X com a gaveta aberta ---------- */
  function utilizavel(el) {
    return !!(el && !el.disabled && !el.hidden && el.getAttribute('aria-disabled') !== 'true' && el.getClientRects().length);
  }
  function focar(el, rolar) {
    // Uma recusa que chega durante a transicao de fechamento nao puxa o foco para uma gaveta que fecha.
    if (!gavetaAberta()) return false;
    if (!el) return false;
    try { el.focus({ preventScroll: !rolar }); } catch (e) { el.focus(); }
    return document.activeElement === el;
  }
  // O nome da linha (link do produto); sem ele, a lixeira da linha.
  function nomeDaLinha(c) {
    if (!c) return null;
    var nome = c.querySelector('.carrinho-item__nome, .cart-summary-item__title');
    if (utilizavel(nome)) return nome;
    var lixeira = c.querySelector('.qty-adjuster__remove');
    return utilizavel(lixeira) ? lixeira : null;
  }
  // Gaveta vazia (spec 6.6): "Continuar comprando", depois o botao do primeiro cartao da faixa.
  function alvoDoVazio() {
    var cta = document.querySelector('.carrinho-vazio__cta');
    if (utilizavel(cta)) return cta;
    var add = document.querySelector('[data-rec-card] [data-rec-add]');
    return utilizavel(add) ? add : null;
  }
  function acaoDaFaixa() {
    var el = faixa();
    var b = el && !el.hidden && el.querySelector('[data-carrinho-aviso-acao]');
    return utilizavel(b) ? b : null;
  }
  // Depois de +/-/Enter: o controle equivalente; desabilitado, oculto ou ausente (ex.: "+" no limite
  // de estoque), o campo e depois o outro botao. A linha sumiu: o nome da que ocupa o lugar dela (a
  // proxima; a ultima, se era a ultima), depois a acao da faixa.
  function alvoDaQuantidade(q, linha) {
    if (linha) {
      var outro = q.controle === 'qty-adjuster__up' ? 'qty-adjuster__down' : 'qty-adjuster__up';
      var ordem = [q.controle, 'qty-adjuster__value', outro];
      for (var i = 0; i < ordem.length; i++) {
        var el = linha.querySelector('.' + ordem[i]);
        if (utilizavel(el)) return el;
      }
    }
    var ls = linhasDaGaveta();
    var vizinha = ls.length ? nomeDaLinha(ls[Math.min(q.indice, ls.length - 1)]) : null;
    return vizinha || acaoDaFaixa();
  }

  /* ---------- foco que sobrevive ao redesenho (I2 da revisao final) ----------
     Todo redesenho troca o no focado e o foco cai no body, inclusive os que a gaveta nao pediu (o app de
     brindes chama updateCartSummaries(false) a cada fg-gifts:updated). Um descritor do ultimo foco dentro
     da gaveta guarda ONDE ele estava (a acao da faixa; o botao, a amostra ou o link de um cartao, pelo
     produto; o controle de uma linha, pela chave) e, depois de qualquer redesenho, com a gaveta aberta e
     o foco no body, ele volta ao equivalente no HTML novo. Os fluxos proprios (adicionar, desfazer,
     quantidade) focam antes, no mesmo redesenho, e prevalecem. O X so como ultimo recurso (spec 5.5). */
  var ultimoFoco = null; // { d: descritor, ativo: a cliente nao tirou o foco por conta propria }
  var CONTROLES_DA_LINHA = ['qty-adjuster__up', 'qty-adjuster__down', 'qty-adjuster__value', 'qty-adjuster__remove', 'carrinho-item__nome'];
  function descreverFoco(el) {
    if (el.hasAttribute('data-carrinho-aviso-acao')) return { tipo: 'aviso' };
    var card = el.closest('[data-rec-card]');
    if (card) {
      var amostra = el.closest('.' + AMOSTRA);
      return { tipo: 'rec', pid: card.getAttribute('data-rec-pid'), vid: amostra ? amostra.getAttribute('data-variant-id') : null, ajuda: el.hasAttribute('data-rec-ajuda') };
    }
    var linha = el.closest('.cart-summary-item-container[data-line-key]');
    if (linha) {
      var controle = 'carrinho-item__nome';
      for (var i = 0; i < CONTROLES_DA_LINHA.length; i++) if (el.classList.contains(CONTROLES_DA_LINHA[i])) controle = CONTROLES_DA_LINHA[i];
      return { tipo: 'linha', chave: linha.getAttribute('data-line-key'), controle: controle, indice: Array.prototype.indexOf.call(linhasDaGaveta(), linha) };
    }
    if (el.hasAttribute('data-rec-seta')) return { tipo: 'seletor', sel: '[data-rec-seta="' + el.getAttribute('data-rec-seta') + '"]' };
    for (var j = 0; j < el.classList.length; j++) if (/^(carrinho-|cart-summary__)/.test(el.classList[j])) return { tipo: 'seletor', sel: '.' + el.classList[j] };
    return { tipo: 'outro' };
  }
  function alvoDoDescritor(d) {
    var g = document.getElementById('cart-summary');
    if (!g || !d) return null;
    if (d.tipo === 'aviso') {
      // A acao da faixa, mesmo desabilitada (aria-disabled segue focavel): o Desfazer em voo fica com o foco.
      var f = faixa();
      var b = f && !f.hidden && f.querySelector('[data-carrinho-aviso-acao]');
      return b && b.getClientRects().length ? b : null;
    }
    if (d.tipo === 'rec') {
      var card = g.querySelector('[data-rec-card][data-rec-pid="' + d.pid + '"]');
      if (card) {
        var r = d.vid && card.querySelector('.' + AMOSTRA + '[data-variant-id="' + d.vid + '"] input[type="radio"]');
        if (utilizavel(r)) return r;
        var link = d.ajuda && card.querySelector('[data-rec-ajuda]');
        if (utilizavel(link)) return link;
        var add = card.querySelector('[data-rec-add]');
        if (utilizavel(add)) return add;
      }
      var primeiro = g.querySelector('[data-rec-card] [data-rec-add]'); // o cartao saiu da faixa (o produto entrou)
      return utilizavel(primeiro) ? primeiro : null;
    }
    if (d.tipo === 'linha') return alvoDaQuantidade(d, linhaPorChave(d.chave));
    if (d.tipo === 'seletor') { var el = g.querySelector(d.sel); return utilizavel(el) ? el : null; }
    return null;
  }
  function ultimoRecurso() {
    var g = document.getElementById('cart-summary');
    if (!g) return null;
    var ordem = [acaoDaFaixa(), nomeDaLinha(linhasDaGaveta()[0]), alvoDoVazio(), g.querySelector('[data-rec-card] [data-rec-add]'), g.querySelector('.carrinho-rodape__cta, .cart-summary__buttons .btn'), g.querySelector('.cart-summary__close')];
    for (var i = 0; i < ordem.length; i++) if (utilizavel(ordem[i])) return ordem[i];
    return null;
  }
  function restaurarFoco() {
    if (!gavetaAberta() || !ultimoFoco || !ultimoFoco.ativo) return;
    var a = document.activeElement;
    if (a && a !== document.body && document.contains(a)) return;
    focar(alvoDoDescritor(ultimoFoco.d) || ultimoRecurso(), false);
  }
  document.addEventListener('focusin', function (e) {
    var g = document.getElementById('cart-summary');
    var t = e.target;
    if (!g || !t || t.nodeType !== 1 || !g.contains(t)) return;
    ultimoFoco = { d: descreverFoco(t), ativo: true };
  });
  // A cliente tirou o foco (toque numa area sem foco, blur): o no segue no documento e o foco foi ao body,
  // e a volta nao se aplica. Um redesenho tira o no do documento: a volta continua valendo.
  document.addEventListener('focusout', function (e) {
    var t = e.target;
    var atual = ultimoFoco;
    if (!atual || e.relatedTarget) return;
    setTimeout(function () {
      var a = document.activeElement;
      if (ultimoFoco === atual && document.contains(t) && (!a || a === document.body)) atual.ativo = false;
    }, 0);
  });

  function desfazer(d) {
    // O Desfazer fica no lugar (com o foco), desabilitado durante o envio; so o texto em volta muda.
    atualizarFaixa(d.nome + ' voltando...', true);
    executarMutacao({ itens: [{ id: d.variante, quantity: d.quantidade, properties: d.propriedades }], variante: d.variante, abrir: false })
      .then(function (resultado) {
        if (resultado === 'confirmada') {
          status(d.nome + ' de volta ao carrinho', { ms: 4000, classe: 'carrinho-aviso--ok' });
          focar(nomeDaLinha(linhaDoGrupo(d.grupo)) || nomeDaLinha(linhasDaGaveta()[0]), true);
        } else if (resultado === 'desconhecida') {
          // O executarMutacao so devolve 'desconhecida' DEPOIS do redesenho da verdade: texto e foco ja podem entrar.
          status('Não deu para confirmar se ' + d.nome + ' voltou. Confira a lista acima', { ms: 8000 });
          focar(nomeDaLinha(linhasDaGaveta()[0]) || acaoDaFaixa() || alvoDoVazio(), true);
        } else if (resultado === 'ocupado') {
          var el = atualizarFaixa('Um instante: atualizando o carrinho...', false); // o Desfazer volta a valer
          if (el) agendarSumico(cfg('msDesfazer', 5000));
        }
      }, function (falha) {
        var el = status((falha && falha.descricao) || ERRO_PADRAO, { ms: 8000, acao: { rotulo: 'Tentar de novo', fn: function () { desfazer(d); } } });
        focar(el && el.querySelector('[data-carrinho-aviso-acao]'), true);
      });
  }
  function viva(p) { return !!p && Date.now() - p.t <= cfg('msPendente', 10000); }
  function depoisDoRedesenhoRemocao() {
    var r = viva(pendenteRemocao) ? pendenteRemocao : null;
    var q = viva(pendenteQuantidade) ? pendenteQuantidade : null;
    pendenteRemocao = null;
    pendenteQuantidade = null;
    if (r) {
      var diferenca = r.totalAntes - totalDoGrupo(r.grupo);
      if (!linhaPorChave(r.chave) || diferenca > 0) {
        if (diferenca > 0) r.quantidade = diferenca; // o grupo partido pode re-criar a chave: devolve o que saiu
        var el = status(r.nome + (feminino(r.nome) ? ' removida' : ' removido'), { ms: cfg('msDesfazer', 5000), acao: { rotulo: 'Desfazer', nome: 'Desfazer remoção de ' + r.nome, fn: function () { desfazer(r); } } });
        focar(el && el.querySelector('[data-carrinho-aviso-acao]'), true);
        return true;
      }
    }
    if (q) {
      var total = totalDoGrupo(q.grupo);
      if (total > 0) {
        var totalEl = document.querySelector('[data-carrinho-total]');
        status(q.nome + ': ' + total + (total === 1 ? ' unidade' : ' unidades') + (totalEl ? '. Total ' + totalEl.textContent.trim() : ''), { ms: 4000 });
      }
      focar(alvoDaQuantidade(q, linhaPorChave(q.chave)), false);
      return true;
    }
    return false;
  }

  /* ---------- adicionar ---------- */
  // O rotulo de "escolher" ("Escolha o tom" ou "Escolha a cor") vem do Liquid e
  // e guardado no botao na primeira passagem, para voltar depois de ocupar/invalidar.
  function rotuloEscolher(add) {
    if (!add.__rotuloEscolher) {
      var t = add.querySelector('[data-rec-add-texto]');
      var atual = (t ? t.textContent : add.textContent) || '';
      add.__rotuloEscolher = /^Escolha/.test(atual) ? atual : 'Escolha o tom';
    }
    return add.__rotuloEscolher;
  }
  function ocuparCartao(card, add, sim) {
    rotuloEscolher(add);
    if (sim) {
      add.setAttribute('aria-busy', 'true');
      add.setAttribute('aria-disabled', 'true');
      card.setAttribute('data-rec-ocupado', '');
      textoDoBotao(add, 'Adicionando...');
    } else {
      add.removeAttribute('aria-busy');
      add.removeAttribute('aria-disabled');
      card.removeAttribute('data-rec-ocupado');
      textoDoBotao(add, add.getAttribute('data-rec-estado') === 'adicionar' ? 'Adicionar' : rotuloEscolher(add));
    }
  }
  // Concordancia pelo primeiro nome: "Base #300 Canela adicionada", "Bastao Anti
  // Inchaco adicionado" (spec 5.5). Feminino: termina em "a" (Mascara) ou "cao"
  // (Locao), mais os femininos que fogem da regra (Base). O resto do catalogo e
  // masculino (Bastao, BBS, Po, Serum, Kit, Combo, Lip, Protetor, Desodorante).
  var FEMININOS = { base: true };
  function feminino(nome) {
    var primeiro = String(nome || '').split(' ')[0].toLowerCase();
    return /a$/.test(primeiro) || /ção$/.test(primeiro) || FEMININOS[primeiro] === true;
  }
  function nomeDoAdicionado(d, v) {
    var nome = d.nome || 'Produto';
    var verbo = feminino(nome) ? 'adicionada' : 'adicionado';
    return nome + (d.temTom ? ' ' + v.tom : '') + ' ' + verbo + ' ao carrinho';
  }
  function adicionar(card, add) {
    if (ocupado) return;
    var d = dadosDoCartao(card);
    var vid = add.getAttribute('data-rec-variante');
    var v = d && varianteDe(card, vid);
    if (!d || !v) return;
    limparErro(card);
    ocuparCartao(card, add, true);
    var frase = nomeDoAdicionado(d, v);
    executarMutacao({
      itens: [{ id: v.id, quantity: 1, properties: { _origem: ORIGEM, _fonte: d.fonte } }],
      variante: v.id,
      abrir: false,
      aoAceitar: function () {
        medir('adicionou', { produto: d.id, variante: v.id, tom: v.tom, fonte: d.fonte, posicao: d.posicao, preco: v.preco });
        try { window.theme.utils.cookie.create('theme_added_to_cart', 'justnow', 1); } catch (e) {}
        esquecerEscolha(card.getAttribute('data-rec-pid'));
      },
    }).then(function (resultado) {
      if (document.contains(add)) ocuparCartao(card, add, false);
      if (resultado === 'confirmada') {
        status(frase, { ms: 4000, classe: 'carrinho-aviso--ok' });
        focarDepoisDeAdicionar(card);
      } else if (resultado === 'desconhecida') {
        // Ja depois do redesenho da verdade (I1): se o produto nao entrou, o cartao dele e um no novo.
        status('Não deu para confirmar se ' + (d.nome || 'o item') + ' entrou. Confira a lista acima', { ms: 8000 });
        var novo = document.querySelector('[data-rec-card][data-rec-pid="' + card.getAttribute('data-rec-pid') + '"] [data-rec-add]');
        focar((utilizavel(novo) && novo) || nomeDaLinha(linhasDaGaveta()[0]) || acaoDaFaixa() || alvoDoVazio(), true);
      }
    }, function (falha) {
      ocuparCartao(card, add, false);
      if (falha && falha.esgotou && d.temTom) invalidarEscolha(card, v.id);
      erroNoCartao(card, (falha && falha.descricao) || ERRO_PADRAO);
      focar(add, true); // pela guarda de gaveta aberta (M1)
    });
  }

  // "Finalizar compra" durante uma mutacao propria: o checkout nao avanca com a
  // adicao sem resolucao. A cliente toca de novo quando a faixa confirmar.
  document.addEventListener('click', function (e) {
    var cta = e.target.closest && e.target.closest('.carrinho-rodape__cta, .cart-summary__buttons .btn');
    if (!cta || !ocupado) return;
    e.preventDefault();
    status('Um instante: atualizando o carrinho...', { ms: 3000 });
  }, true);

  document.addEventListener('click', function (e) {
    var alvo = e.target;
    if (!alvo || !alvo.closest) return;

    var add = alvo.closest('[data-rec-add]');
    if (add) {
      e.preventDefault();
      var card = add.closest('[data-rec-card]');
      if (!card || card.hasAttribute('data-rec-ocupado')) return;
      if (add.getAttribute('data-rec-estado') === 'adicionar') { adicionar(card, add); return; }
      // "Escolha o tom": leva o foco ao primeiro radio disponivel e escreve a dica.
      var primeiro = card.querySelector('.' + AMOSTRA + ' input[type="radio"]:not(:disabled)');
      var d = dadosDoCartao(card) || {};
      var texto = (card.querySelector('[data-rec-add-texto]') || {}).textContent || '';
      var ehTom = /tom/i.test(texto);
      status('Escolha ' + (ehTom ? 'um tom' : 'uma cor') + ' nas amostras para adicionar ' + (d.nome || ''), { ms: 5000 });
      if (primeiro) primeiro.focus();
      medir('interagiu', { gesto: 'botao' }, true);
      return;
    }

    var seta = alvo.closest('[data-rec-seta]');
    if (seta) {
      e.preventDefault();
      var faixaEl = seta.closest('[data-rec]') && seta.closest('[data-rec]').querySelector('[data-rec-faixa]');
      var cartao = faixaEl && faixaEl.querySelector('[data-rec-card]');
      if (!faixaEl || !cartao) return;
      var passo = cartao.getBoundingClientRect().width + 10;
      var reduzido = false;
      try { reduzido = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (err) {}
      var dx = passo * parseInt(seta.getAttribute('data-rec-seta'), 10);
      if (typeof faixaEl.scrollBy === 'function') faixaEl.scrollBy({ left: dx, behavior: reduzido ? 'auto' : 'smooth' });
      else faixaEl.scrollLeft += dx;
      medir('interagiu', { gesto: 'seta' }, true);
      return;
    }

    var ajuda = alvo.closest('[data-rec-ajuda]');
    if (ajuda) {
      var c = ajuda.closest('[data-rec-card]');
      medir('ajuda', { produto: c ? parseInt(c.getAttribute('data-rec-pid'), 10) : null });
    }
  });

  // Deslizar a faixa com o dedo conta como gesto (uma vez por abertura).
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.nodeType === 1 && t.hasAttribute && t.hasAttribute('data-rec-faixa')) medir('interagiu', { gesto: 'deslizou' }, true);
  }, true);

  /* ---------- abriu e viu ----------
     viu = faixa a 50%+ por 1 s CONTINUO, com a gaveta aberta, uma vez por abertura.
     O timer e cancelado ao fechar, ao redesenhar (a faixa e trocada) e ao sair de vista. */
  var observadorViu = null;
  var timerViu = null;
  function cancelarViu() {
    clearTimeout(timerViu);
    timerViu = null;
    if (observadorViu) { observadorViu.disconnect(); observadorViu = null; }
  }
  function observarFaixa() {
    cancelarViu();
    var faixaEl = document.querySelector('[data-rec-faixa]');
    if (!faixaEl || !window.IntersectionObserver) return;
    if (!document.body.classList.contains('show-cart-summary')) return;
    var raiz = faixaEl.closest('.cart-summary__item-list') || null;
    observadorViu = new IntersectionObserver(function (entradas) {
      var visivel = entradas[0] && entradas[0].intersectionRatio >= 0.5;
      if (visivel && !timerViu) {
        timerViu = setTimeout(function () {
          timerViu = null;
          if (!document.body.classList.contains('show-cart-summary') || !document.contains(faixaEl)) return;
          var sec = faixaEl.closest('[data-rec]');
          medir('viu', { cartoes: faixaEl.querySelectorAll('[data-rec-card]').length, fontes: sec ? sec.getAttribute('data-rec-fontes') : '' }, true);
        }, cfg('msViu', 1000));
      } else if (!visivel) {
        clearTimeout(timerViu);
        timerViu = null;
      }
    }, { root: raiz, threshold: [0, 0.5, 1] });
    observadorViu.observe(faixaEl);
  }
  /* ---------- teclado (spec 5.5): Esc fecha pelo toggle do tema; Tab fica dentro da gaveta ----------
     O theme.js NAO tem Esc nem prisao de Tab para a gaveta (conferido em 30/09/2026: o Esc dele e do
     popup e da busca; a gaveta fecha pelo overlay e pelo .toggle-cart-summary). Com a gaveta fechada
     nada acontece, entao o Esc da busca do tema segue so dele. */
  document.addEventListener('keydown', function (e) {
    if (e.defaultPrevented || !gavetaAberta()) return;
    var gaveta = document.getElementById('cart-summary');
    if (!gaveta) return;
    if (e.key === 'Escape') {
      var x = gaveta.querySelector('.toggle-cart-summary');
      if (x) { e.preventDefault(); x.click(); }
      return;
    }
    if (e.key !== 'Tab') return;
    var focaveis = gaveta.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), textarea, [tabindex]:not([tabindex="-1"])');
    var vis = [];
    for (var i = 0; i < focaveis.length; i++) if (focaveis[i].offsetParent !== null || focaveis[i].getClientRects().length) vis.push(focaveis[i]);
    if (!vis.length) return;
    var primeiro = vis[0], ultimo = vis[vis.length - 1];
    if (e.shiftKey && document.activeElement === primeiro) { e.preventDefault(); ultimo.focus(); }
    else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primeiro.focus(); }
    else if (!gaveta.contains(document.activeElement)) { e.preventDefault(); primeiro.focus(); }
  });

  var acionador = null;
  function observarAbertura() {
    if (!window.MutationObserver || !document.body) return;
    var aberta = document.body.classList.contains('show-cart-summary');
    if (aberta) abriu();
    new MutationObserver(function () {
      var agora = document.body.classList.contains('show-cart-summary');
      if (agora && !aberta) {
        // antes de o tema focar o X (200 ms depois), o foco ainda esta em quem abriu
        acionador = document.activeElement && document.activeElement !== document.body ? document.activeElement : null;
        abriu();
      }
      if (!agora && aberta) {
        cancelarViu();
        desmarcarFaixa();
        ultimoFoco = null; // gaveta fechada: nenhum redesenho devolve o foco a ela
        if (acionador && document.body.contains(acionador)) { try { acionador.focus(); } catch (e) {} }
      }
      aberta = agora;
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }
  function abriu() {
    medido = {}; // viu e interagiu contam uma vez POR ABERTURA (abertura != sessao)
    var totalEl = document.querySelector('[data-carrinho-total]');
    medir('abriu', { itens: document.querySelectorAll('.cart-summary-item-container').length, total: totalEl ? totalEl.textContent.trim() : null });
    restaurarEscolhas(document);
    observarFaixa();
  }

  /* ---------- redesenho leve (spec 7): ?sections=cart-drawer,header no lugar de /search ----------
     So com data-redesenho-leve no #cart-summary (configuracao redesenho_leve da section).
     aplicarHtml e copia FIEL do corpo de theme.updateCartSummaries (theme.js 3778 a 3879),
     trocando so a origem do HTML. Qualquer falha: o original (/search).
     A CHAVE e lida UMA vez por pagina, na primeira chamada, e guardada: o HTML que volta
     (do ?sections= ou do /search) nao precisa trazer o atributo para o caminho seguir o
     mesmo ate a proxima carga (a chave so muda com a pagina recarregada). E na primeira
     chamada, e nao no DOMContentLoaded, porque ate la nada troca o #cart-summary e o
     teste "chave desligada" tira o atributo depois da carga.
     O PRAZO cobre o corpo (fetchJsonComTimeout): um corpo que trava depois do cabecalho
     cai no original, nunca deixa a gaveta pendurada.
     Este envoltorio NUNCA lanca na hora da chamada: quem chama (pdp-offer, compre junto)
     trata excecao como "ir ao /cart".
     INTENCAO SOMADA: so a chamada mais nova troca a pagina, mas com os flags de TODAS as
     chamadas ainda nao aplicadas (OU de cada um). O app de brindes chama (false) a cada
     fg-gifts:updated (snippets/freegifts-snippet.liquid) e o tema chama (false) nas
     quantidades: em cima de uma adicao da PDP (true, true, ...), sem a soma a gaveta ficaria
     fechada, sem o X e sem o slideDown. O original, no fallback, recebe a mesma soma.
     Zera depois de aplicar ou de cair no original.
     ERRO DEPOIS DA TROCA (ex.: um inscrito de cc-cart-updated que lanca): a pagina ja esta
     certa; um 2o redesenho pelo /search destruiria o foco e a faixa de status. So fecha o
     carregando e avisa no console. */
  function instalarRedesenhoLeve() {
    var tema = window.theme;
    if (!tema || typeof tema.updateCartSummaries !== 'function' || tema.__biobioRedesenhoLeve) return;
    var original = tema.updateCartSummaries;
    var ultimaChamada = 0;
    var chave = null; // null: ainda nao lida
    var intencao = null; // flags somados das chamadas ainda nao aplicadas
    function fecharCarregando() { if (typeof tema.cartLoadingFinished === 'function') tema.cartLoadingFinished(); }
    function noOriginal() {
      var i = intencao || { abrir: false, adicao: false, atrasar: false };
      intencao = null;
      return original.call(tema, i.abrir, i.adicao, i.atrasar);
    }
    tema.__biobioRedesenhoLeve = true;
    tema.updateCartSummaries = function (showCartSummary, isAddToCart, delayQtyAdjusterShow) {
      var args = arguments;
      var gaveta = document.getElementById('cart-summary');
      if (chave === null) chave = !!(gaveta && gaveta.hasAttribute('data-redesenho-leve'));
      var $ = jqDoTema(); // a MESMA instancia em que o tema dispararia cc-cart-updated
      if (!chave || !gaveta || !$) return original.apply(tema, args);
      intencao = {
        abrir: !!showCartSummary || !!(intencao && intencao.abrir),
        adicao: !!isAddToCart || !!(intencao && intencao.adicao),
        atrasar: !!delayQtyAdjusterShow || !!(intencao && intencao.atrasar),
      };
      var chamada = ++ultimaChamada;
      var estado = { trocou: false };
      var url, itemListScrollTop, innerScrollTop;
      try {
        if (typeof tema.cartLoadingStarted === 'function') tema.cartLoadingStarted();
        itemListScrollTop = $('.cart-summary__item-list:first').scrollTop();
        innerScrollTop = $('.cart-summary__inner:first').scrollTop();
        var raiz = (tema.routes && tema.routes.root_url) || '/';
        url = raiz + (raiz.indexOf('?') > -1 ? '&' : '?') + 'sections=cart-drawer,header';
      } catch (e) {
        return noOriginal();
      }
      fetchJsonComTimeout(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } }, cfg('timeoutSections', 8000))
        .then(function (r) {
          if (chamada !== ultimaChamada) return; // uma chamada mais nova foi feita: esta resposta e descartada (o passo seguinte fecha o carregando)
          if (!r.resposta.ok) throw new Error('HTTP ' + r.resposta.status);
          var valido = validarSections(r.dados);
          if (!valido) throw new Error('resposta incompleta');
          var i = intencao || { abrir: !!showCartSummary, adicao: !!isAddToCart, atrasar: !!delayQtyAdjusterShow };
          aplicarHtml($, valido, i.abrir, i.adicao, i.atrasar, itemListScrollTop, innerScrollTop, estado);
          intencao = null;
          return true;
        })
        .then(function (aplicou) {
          if (!aplicou) fecharCarregando();
        }, function (erro) {
          // Falha de uma chamada que ja tem outra mais nova: quem decide e a mais nova (nada de /search a toa).
          if (chamada !== ultimaChamada) { fecharCarregando(); return; }
          if (estado.trocou) {
            intencao = null;
            fecharCarregando();
            try { console.warn('[biobio-carrinho] redesenho leve: erro depois da troca (sem 2o redesenho): ' + (erro && erro.message ? erro.message : erro)); } catch (e) {}
            return;
          }
          noOriginal();
        });
    };
  }
  // So troca a pagina com a resposta COMPLETA: as duas sections, a gaveta com
  // #LimitedCartJson valido e o contador no cabecalho. A Shopify pode devolver
  // HTTP 200 com uma section null. A conferencia parseia num documento INERTE (como o
  // $.parseHTML do jQuery): uma resposta recusada nao baixa imagem nem roda atributo on*.
  function validarSections(json) {
    if (!json || typeof json['cart-drawer'] !== 'string' || typeof json.header !== 'string') return null;
    var inerte;
    try { inerte = document.implementation.createHTMLDocument(''); } catch (e) { return null; }
    var tmp = inerte.createElement('div');
    tmp.innerHTML = json['cart-drawer'];
    var gaveta = tmp.querySelector('.cart-summary');
    var limitado = tmp.querySelector('#LimitedCartJson');
    if (!gaveta || !limitado) return null;
    try { JSON.parse(limitado.textContent); } catch (e) { return null; }
    var tmp2 = inerte.createElement('div');
    tmp2.innerHTML = json.header;
    if (!tmp2.querySelector('.toolbar-cart .current-cart')) return null;
    return json['cart-drawer'] + json.header;
  }
  function aplicarHtml($, data, showCartSummary, isAddToCart, delayQtyAdjusterShow, itemListScrollTop, innerScrollTop, estado) {
    var tema = window.theme;
    var selectors = ['.toolbar-cart .current-cart', '.cart-summary'];
    var $parsed = $($.parseHTML('<div>' + data + '</div>')).wrap('<div>').parent();
    for (var i = 0; i < selectors.length; i++) {
      var sel = selectors[i];
      var $novo = $parsed.find(sel).clone();
      if (!$novo.length) continue;
      $novo.find('.fade-in').removeClass('fade-in');
      var $atual = $(sel);
      var $buttonContainer = $novo.find('.cart-summary__buttons');
      if ($buttonContainer.length) $buttonContainer.css('height', $atual.find('.cart-summary__buttons').outerHeight() + 'px');
      var $novoItem = $novo.find('.cart-summary-item-container').eq(0);
      if ($atual.find('.cart-summary-item-container[data-product-id="' + $novoItem.data('product-id') + '"]').length) isAddToCart = false;
      if (isAddToCart && $novoItem.length) $novoItem.addClass('cart-summary-item-container--out-left').hide();
      // theme.js 3813 a 3818: rodape sticky do tema ganha o top negativo da parte nao fixa
      var $cartForm = $('.cart-form--checkout', $atual);
      var $cartFormNonStick = $('.cart-form--non-stick', $atual);
      if ($cartForm.hasClass('cart-form--checkout--sticky-true') && $cartFormNonStick.length) {
        $novo.find('.cart-form--checkout').css('top', -Math.abs(parseInt($cartFormNonStick.outerHeight() + 1, 10)) + 'px');
      }
      if (estado) estado.trocou = true; // daqui em diante a pagina ja mudou: erro nao cai no /search
      $atual.replaceWith($novo);
      if (isAddToCart && $novoItem.length) { $novoItem.slideDown(300); $novoItem.removeClass('cart-summary-item-container--out-left'); }
      if ($buttonContainer.length) (function (s) { setTimeout(function () { $(s).find('.cart-summary__buttons').css('height', 'auto'); }, 1000); })(sel);
    }
    var cartItemData;
    if ($('#LimitedCartJson').length) {
      cartItemData = JSON.parse($('#LimitedCartJson').html());
      if (delayQtyAdjusterShow) setTimeout(function () { tema.loadInPlaceQuantityAdjustment($('body'), cartItemData); }, 800);
      else tema.loadInPlaceQuantityAdjustment($('body'), cartItemData);
      tema.applyAjaxToProductForm($('.cart-summary form.product-form'));
    }
    tema.loadCartNoteMonitor($('.cart-summary'));
    $('.cart-summary__item-list:first').scrollTop(itemListScrollTop);
    $('.cart-summary__inner:first').scrollTop(innerScrollTop);
    if (tema.settings.cartType != 'page') {
      if (showCartSummary) {
        setTimeout(function () {
          $('body').addClass('show-cart-summary product-added-to-cart');
          setTimeout(function () { $('.cart-summary__close').focus(); }, 200);
        }, 20);
      }
      $('.cart-summary.updating, .cart-summary .updating').removeClass('updating');
      if (cartItemData) $(window).trigger('cc-cart-updated', { cartItemData: cartItemData });
    }
    if (typeof tema.cartLoadingFinished === 'function') tema.cartLoadingFinished();
  }

  function iniciar() {
    noAnunciador(); // o role=status existe desde a carga, antes da primeira mensagem (I3)
    inscreverRedesenho();
    observarQuantidade();
    // Gaveta fechada no carregamento (uma PDP comum): nada marcado na faixa, nem o que
    // o navegador restaurar do formulario ao voltar pelo historico.
    if (!gavetaAberta()) desmarcarFaixa();
    observarAbertura();
    instalarRedesenhoLeve();
  }
  // ORDEM DE CARGA: no theme.liquid a section cart-drawer (linha 194) vem antes
  // de vendor.min.js (jQuery, 380) e theme.js (381), todos defer; scripts defer
  // rodam na ordem do documento, entao ESTE arquivo executa antes de jQuery e
  // theme existirem (readyState "interactive"). DOMContentLoaded so dispara
  // depois de todos os defer: e la que iniciar() pode contar com os dois.
  if (document.readyState === 'complete') iniciar();
  else document.addEventListener('DOMContentLoaded', iniciar);

  /* ---------- LEGADO: o form do markup antigo da section (commit 32c596e) ----------
     Fica como rede de seguranca: se um push de outra frente devolver o bloco
     promo_products antigo, o COMPRAR continua adicionando por AJAX. ---------- */
  var FORM = '.cart-summary__promo-products form';
  var AVISO = 'carrinho-compra__erro';
  function temaAssumiu(form) {
    return form.classList.contains('product-form-loaded') || !form.getAttribute('action');
  }
  function ocupadoLegado(botao, sim) {
    if (!botao) return;
    botao.disabled = sim;
    botao.classList.toggle('product-add--adding', sim);
    if (sim) botao.setAttribute('aria-busy', 'true'); else botao.removeAttribute('aria-busy');
  }
  function acharAviso(form) {
    var irmao = form.nextElementSibling;
    return irmao && irmao.classList.contains(AVISO) ? irmao : null;
  }
  function avisar(form, mensagem) {
    var aviso = acharAviso(form);
    if (!aviso) {
      aviso = document.createElement('p');
      aviso.className = AVISO;
      aviso.setAttribute('role', 'alert');
      aviso.style.cssText = 'margin:6px 0 0;color:#b3261e;font-size:12px;line-height:1.35';
      form.parentNode.insertBefore(aviso, form.nextSibling);
    }
    aviso.textContent = mensagem;
  }
  document.addEventListener('submit', function (evento) {
    var form = evento.target;
    if (!form || typeof form.matches !== 'function' || !form.matches(FORM)) return;
    if (evento.defaultPrevented || temaAssumiu(form)) return;
    evento.preventDefault();
    var botao = form.querySelector('[type="submit"]');
    if (botao && botao.disabled) return;
    var tema = window.theme || {};
    var rota = ((tema.routes && tema.routes.cart_add_url) || '/cart/add') + '.js';
    var corpo = new URLSearchParams(new FormData(form));
    if (!corpo.has('quantity')) corpo.set('quantity', '1');
    var avisoVelho = acharAviso(form);
    if (avisoVelho) avisoVelho.parentNode.removeChild(avisoVelho);
    ocupadoLegado(botao, true);
    fetch(rota, { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: corpo })
      .then(function (resposta) {
        return resposta.json().catch(function () { return {}; }).then(function (dados) {
          if (!resposta.ok) {
            var falha = new Error('HTTP ' + resposta.status);
            falha.descricao = typeof dados.description === 'string' && dados.message !== 'Cart Error' ? dados.description : '';
            throw falha;
          }
          return dados;
        });
      })
      .then(function () {
        try { tema.utils.cookie.create('theme_added_to_cart', 'justnow', 1); } catch (e) {}
        if (typeof tema.updateCartSummaries === 'function') {
          tema.updateCartSummaries(true, true, false);
          setTimeout(function () { ocupadoLegado(botao, false); }, 500);
        } else {
          window.location.reload();
        }
      })
      .catch(function (falha) {
        ocupadoLegado(botao, false);
        avisar(form, (falha && falha.descricao) || ERRO_PADRAO);
      });
  });
})();
